export default function Community() {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h1 className="mb-4">Join Our Community</h1>
            <p className="lead">
              Connect with other users, share tips, and shape the future of AI-powered inventory management.
            </p>
            <div className="alert alert-warning mt-4">
              <p className="mb-0">
                Our official community forum is coming soon! Stay tuned via our <a href="https://aksemai-inventory.netlify.app/" target="_blank" rel="noreferrer" className="text-primary">website</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }